import React, { useEffect } from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';

import FormColorPicker from '../common/inputs/FormColorPicker';
import BoardColorOption from './BoardColorOption';

function BoardColorPicker({
  value,
  onChange,
  boardColors,
  isNotDisplay = false,
  allowClear = false,
}) {
  useEffect(() => {
    if (!isNotDisplay || !boardColors?.length) return;
    if (!value) {
      if (allowClear) return;
      onChange(boardColors[0].color);
      return;
    }
    if (!boardColors.some((entry) => entry.color === value)) {
      onChange(boardColors[0].color);
    }
  }, [isNotDisplay, value, boardColors, onChange, allowClear]);

  if (boardColors?.length) {
    if (isNotDisplay) {
      return (
        <Select
          value={value}
          onChange={onChange}
          optionFilterProp="label"
          allowClear={allowClear}
        >
          {boardColors.map((color) => (
            <Select.Option key={color.id} value={color.color} label={color.label}>
              <BoardColorOption color={color.color} label={color.label} />
            </Select.Option>
          ))}
        </Select>
      );
    }
    const fallback = value ? { color: value, label: value } : { color: '#FFFFFF', label: 'Not set' };
    const selected = boardColors.find((color) => color.color === value) ?? fallback;
    return (
      <BoardColorOption color={selected.color} label={selected.label} />
    );
  }
  return (
    <FormColorPicker
      value={value}
      onChange={onChange}
      isNotDisplay={isNotDisplay}
      allowClear={allowClear}
    />
  );
}

BoardColorPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  boardColors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  isNotDisplay: PropTypes.bool,
  allowClear: PropTypes.bool,
};

BoardColorPicker.defaultProps = {
  value: undefined,
  boardColors: [],
  isNotDisplay: false,
  allowClear: false,
};

export default BoardColorPicker;
